const wowApp = require('angular').module('wowApp.common');
wowApp.directive('bwsExploreCategories', ['CatalogService', 'BreakpointsService', require('./explore-category.js')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/explore-categories/index.js
 **/